import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  businessClientWillObtainFinancialData: {
    defaultMessage: "{clientName} will be given access to your company's financial information.",
    id: 'ThirdPartyLabel.businessClientWillObtainFinancialData',
  },
  clientWillObtainFinancialData: {
    defaultMessage: '{clientName} will obtain some of your financial information.',
    id: 'ThirdPartyLabel.clientWillObtainFinancialData',
  },
  clientWillObtainAndDisplayFinancialData: {
    defaultMessage:
      'Tink will fetch a list of your accounts, transactions and account balances, and provide consolidated account information.',
    id: 'ThirdPartyLabel.clientWillObtainAndDisplayFinancialData',
  },
  clientWillObtainAccountInformation: {
    defaultMessage:
      'Tink will retrieve your account information and share it with {clientName}{isAbbreviated, select, true {} other {.}}',
    id: 'ThirdPartyLabel.clientWillObtainAccountInformation',
  },
});
